import Axios from 'axios';
import Helper from './Helper';

Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const webAPIURL = () => {
    let baseURL = `${new URL(window.location.origin)}`
    let url = `${baseURL}curriculum-api`;
    return url
};

// function getCsrfToken() {
//     return document.cookie
//         .split('; ')
//         .find(row => row.startsWith('CURRICULUM-XSRF-TOKEN='))
//         ?.split('=')[1];
// }
//const token = document.cookie.split('; ').find(row => row.startsWith('CURRICULUM-XSRF-TOKEN='))?.split('=')[1];

const instance = Axios.create({
    withCredentials: true,
    baseURL: webAPIURL(),
    timeout: 1000000,
    // headers: {
    //     'X-CURRICULUM-XSRF-TOKEN': Helper.getCookie('CURRICULUM-XSRF-TOKEN'),
    // }
})

export default class CurriculumAPIHelper {


    static get(url, headers = {}, obj) {
        return new Promise((resolve, reject) => {
            instance
                .get(url, { headers })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static post(url, obj, headers = { 'Content-Type': 'application/json', Accept: 'application/json' }) {

        return new Promise((resolve, reject) => {
            instance
                .post(url, obj, { headers })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }




    static delete(url) {

        return new Promise((resolve, reject) => {
            instance
                .delete(url)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}